import React, { useMemo } from 'react';
import FILE_ICON_MAP from './fileIconsMapping';
import './styles.less';

const FileIcon = ( { mimeType } ) => {

    const fileType = useMemo( ()=> {
        return Object.values( FILE_ICON_MAP ).find( f => f.checkFileType( mimeType ) );
    }, [ mimeType ] );

    return (
        <div className="file-icon">
            { fileType.icon }
        </div>
    );
};

export default FileIcon;
